<template>
  <div class="app-container">
    <el-form class="header-filter">
      <div class="filter-container">
        <div class="filter-form">
          <el-form-item>
            <el-input
              v-model="query.condition"
              @keyup.enter.native="resetList"
              placeholder="用户名"
            />
          </el-form-item>
        </div>
        <div class="filter-btns">
          <el-button @click="resetList" type="primary">确认查询</el-button>
          <el-button @click="handleCreate">新增</el-button>
        </div>
      </div>
    </el-form>

    <div class="table-wrapper">
      <el-table :data="list" v-loading="listLoading">
        <el-table-column align="center" type="index" width="60" label="#"></el-table-column>
        <el-table-column align="center" prop="name" label="角色名"></el-table-column>
        <el-table-column align="center" prop="tips" label="描述"></el-table-column>
        <el-table-column align="center" label="创建时间">
          <template> 2021-02-28 </template>
        </el-table-column>

        <el-table-column align="left" label="表格操作" width="250">
          <template slot-scope="scope">
            <div style="margin: 7px 0; height: 66px">
              <p v-if="scope.row.id != 1" style="margin-bottom: 10px">
                <el-button type="primary" size="mini" @click="handleUpdate(scope.row)">
                  编辑
                </el-button>
                <el-button type="danger" size="mini" @click="handleDelete(scope.row.code)">
                  删除
                </el-button>
              </p>
              <p v-if="scope.row.id != 1">
                <el-button size="mini" @click="handleMenus(scope.row)">配置菜单</el-button>
              </p>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="query.page"
          :total="listTotal"
          :page-sizes="[10, 20, 30, 50]"
        />
      </div>
    </div>

    <role-dialog ref="dialog" @listenPostSuccess="getList"></role-dialog>
    <role-menus ref="menus" @listenPostSuccess="getList" :authTree="permissionRouters"></role-menus>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { getRoleList, deleteRole, getRoleMenu } from '@/api/admin'
import RoleMenus from './components/role-menus'
import RoleDialog from './components/role-dialog'

export default {
  components: {
    RoleMenus,
    RoleDialog
  },

  data() {
    return {
      // table
      list: [],
      listTotal: null,
      listLoading: false,

      query: {
        current: 1,
        limit: 10
      },

      // other
      authTree: [],
      frontMenuIds: [], // 前端路由 id
      dialogLoading: false
    }
  },

  computed: {
    ...mapState({
      permissionRouters: (state) => state.permission.filterRouters
    })
  },

  created() {
    this.authTree = JSON.parse(JSON.stringify(this.permissionRouters))
    this.authTree.forEach((parentMenu) => {
      parentMenu.children = parentMenu.children.filter((menu) => !menu.hidden)
    })

    this.getList()

    this.authTree = this.authTree.map((item) => {
      // 给父级添加 title 在 dialog 显示
      item.meta = item.meta ? item.meta : item.children[0].meta

      // 拼接前端路由 id
      item.children.forEach((child) => {
        this.frontMenuIds.push(child.id)
      })

      return item
    })
  },

  methods: {
    resetList() {
      this.query.current = 1

      this.getList()
    },

    getList() {
      this.listLoading = true

      getRoleList(this.query).then((res) => {
        const {
          data: {
            records,
            pager: { itemCount }
          }
        } = res
        this.list = records
        this.listTotal = +itemCount
        this.listLoading = false
        console.log('角色列表 :>> ', records)
      })
    },

    handleSizeChange(val) {
      this.query.limit = val
      this.resetList()
    },

    handleCurrentChange(val) {
      this.query.current = val
      this.getList()
    },

    handleCreate() {
      this.$refs.dialog.handleCreate()
    },

    handleMenus(row) {
      getRoleMenu(row.code).then((res) => {
        const menus = []

        res.data.roleTreeList.forEach((item) => {
          // 后端的路由 id 与前端的路由 id 匹配，过滤多余的权限
          if (item.checked && this.frontMenuIds.indexOf(item.code) !== -1) {
            menus.push(item.code)
          }
        })

        this.dialogLoading = false
        this.$refs.menus.handleUpdate({
          code: row.code,
          menus
        })
      })
    },

    handleUpdate(row) {
      this.$refs.dialog.handleUpdate({
        code: row.code,
        name: row.name,
        tips: row.tips
      })
    },

    handleDelete(code) {
      this.$confirm('此操作将永久删除该角色, 是否继续?', '提示', {}).then(() => {
        deleteRole(code).then(() => {
          this.$message.success('删除角色成功')
          this.getList()
        })
      })
    }
  }
}
</script>
